import React from 'react';
import { Page } from './Page';
export function FoodPhoto({
  src,
  alt,
  caption,
  pageNumber
}: {
  src: string;
  alt: string;
  caption?: string;
  pageNumber?: number;
}) {
  return <Page hideFooter variant="light" data-id="element-104" data-mp="ceyp7zecft43">
      <div className="flex flex-col h-full -mx-4 -mt-2" data-id="element-105" data-mp="cg046eyhczr3">
        <div className="flex-1 overflow-hidden min-h-0" data-id="element-106" data-mp="8dwqdjoc9j2n">
          <img src={src} alt={alt} className="w-full h-full object-cover" data-id="element-107" data-mp="8fg4p4qfpk1s" />
        </div>
        <div className="flex items-start justify-between pt-4 px-1" data-id="element-108" data-mp="153e5ep97ohh0">
          <p className="text-[11px] text-[#7A7A70] tracking-wide" data-id="element-109" data-mp="104jc2tdmbain">
            {caption || 'Structured Nutrition | The GLP-1 Nutrition Guide'}
          </p>
          <div className="flex flex-col items-center gap-1 shrink-0 ml-4" data-id="element-110" data-mp="vbq847pz467m">
            <div className="w-12 h-12 border border-[#D8D8D0] bg-[#EAEAE4] flex items-center justify-center" data-id="element-111" data-mp="rc8zj5f92sy8">
              <span className="text-[8px] font-bold text-[#7A7A70]" data-id="element-112" data-mp="1nwhzucu96yco">QR</span>
            </div>
            <p className="text-[8px] text-[#7A7A70]" data-id="element-113" data-mp="1j2dprkpoya7d">Scan to get the recipe</p>
          </div>
        </div>
      </div>
    </Page>;
}